var exports = {
  "P": "x804f0401--1b3b8b--label",
  "D": "x804f0401--1b3b8b--title",
};

module.exports = exports;
